import qs, { IParseOptions } from 'qs';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { TAssetsOrderTab } from '@webtrader/core/constants/order';
import { ELanguageQueryString } from '@webtrader/core/i18n/constants';

export interface IWebQueryStringParams {
  token?: string;
  symbol?: string;
  assetsOrderTab?: TAssetsOrderTab;
  extToken?: string;
  lang?: ELanguageQueryString;
}

export const queryStringParams = (search: string, options?: IParseOptions) => {
  return qs.parse(search, { ignoreQueryPrefix: true, ...options }) as IWebQueryStringParams;
};

export const useQueryParams = (options?: IParseOptions): IWebQueryStringParams => {
  const location = useLocation();

  const search = location.search;

  const [qsOptions] = useState(options);

  const query = useMemo(() => queryStringParams(search, qsOptions), [search, qsOptions]);

  return query;
};
